/** @deprecated Use GridContainer size='lg' instead. */
export const DEFAULT_GRID_HEIGHT = '80vh';
/**
 * Minimum width of a filter dropdown sitting above a grid. Shared so the
 * Client's Wealth sub-tabs (Accounts, Holdings) line their filter rows up
 * instead of drifting apart when one page tweaks its own copy.
 */
export const FILTER_MIN_WIDTH = 280;
export const WIDGET_GRID_HEIGHT = 400;
export const BALANCE_DESC_GRID_SORT_MODEL = [
  { field: 'Balance', sort: 'desc' as const },
];
export const BALANCE_DESC_API_SORT = [
  { property: 'Balance', direction: 'desc' as const, order: 0 },
];
